import { withApollo } from "react-apollo";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
class GenericMasterFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      errors: [],
      error: "",
      loading: false,
      currentPage: 1
    };

    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this.initialState = this.state;
  }

  resetForm() {
    this.setState({ ...this.initialState });
    this.props.filterAction();
    this.props.filterOnChange(this.initialState);
  }

  submitForm() {
    this.props.filterAction();
    this.props.filterOnChange(this.state);
  }

  render() {
    const { showFilter } = this.props;
    const { description } = this.state;

    return (
      <div
        className="filter-popup"
        style={showFilter ? { display: "block" } : { display: "none" }}
      >
        <h4>FILTER</h4>
        <form className="m-t-15">
          <div className="form-group">
            <label>DESCRIPTION</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Description to Search"
              style={{ textTransform: "uppercase" }}
              value={description}
              onChange={e => {
                this.setState({
                  description: e.target.value
                });
              }}
            />
          </div>
          <div className="row">
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-light btn-block"
                onClick={this.resetForm}
              >
                Clear
              </button>
            </div>
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-danger btn-block"
                onClick={this.submitForm}
              >
                Apply
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(connect()(withApollo(GenericMasterFilter)));
